import { getCurrentUser } from '@wix/communities-blog-client-common';
import { getUserRole } from '../services/user-role';
import { ROLE_GUEST_WRITER } from '@wix/communities-blog-universal/dist/src/permissions-checker-constants';

export const getIsUserGuestWriter = (state) => {
  const user = getCurrentUser(state);

  return getUserRole(user) === ROLE_GUEST_WRITER;
};
